













































import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import ErrorMessage from "@/components/messages/ErrorMessage.vue";
import Loading from "@/components/Loading.vue";
import helper from "@/plugins/helper";
interface FormInput {
    type:String,
    items:[],
    name:String
}
class snackbar {
    enabled:boolean=false;
    text:string="";
    timeout:number = 5000;
    color:String="success";
}
@Component({
    components: {Loading, ErrorMessage},
})
export default class EForm<S> extends Vue{

    @Prop({default:false}) displayCancelButton!:boolean;
    @Prop({default:'POST'}) method!:string;
    @Prop({default:''}) title!:string;
    @Prop({}) action!:string;
    @Prop({default:2000}) maxWidth!:number;

    //@Prop({default : Array<FormInput>()}) inputs!:Array<FormInput>;
    cancelButtonLabel:string="Cancel";
    @Prop({})
    data!:any;
    error:AxiosError|null = null;
    config:AxiosRequestConfig = {
        headers:[]
    };
    onFly:boolean=false;
    snackbar: snackbar = new snackbar();
    mounted(){
        //console.log("ss",this.inputs);
        if(this.method == null){
            this.method = "POST"
        }
    }
    reset(){
        this.error=null;
    }
    cancel(){
        this.$emit('cancel');
    }
    async onSubmit (e:Event) {
        e.preventDefault();
        this.onFly=true;
        let prom:any;
        let keys = Object.keys(this.data);
        keys.forEach(key=>{
            if(Array.isArray(this.data[key])){
                this.data[key] = JSON.stringify(this.data[key]);
            }
        })
        try{
            if(this.method == "POST"){
                prom = await<AxiosResponse> Vue.prototype.$http.post(this.action,this.data)
            }
            if(this.method == "COPY"){
                prom = await<AxiosResponse>  Vue.prototype.$http.request({
                    method:"COPY",
                    responseType:"json",
                    data:JSON.stringify(this.data),
                    transformRequest:[function (data:any, headers:any) {
                        return data;
                    }],
                    url:this.action
                });
               // prom = await<AxiosResponse> Vue.prototype.$http.copy(this.action,this.data)
            }
            if(this.method == "PUT"){
                prom = await<AxiosResponse> Vue.prototype.$http.put(this.action,this.data)
            }
            if(this.method == "GET"){
                prom = await<AxiosResponse> Vue.prototype.$http.get(this.action,this.data)
            }
            //console.log(prom.data);
            this.snackbar = new snackbar();
            this.snackbar.enabled = true;
            this.onFly = false;
            if(typeof prom.data.message != "undefined"){
                this.snackbar.text = prom.data.message
            }
            else if(typeof prom.data.messages != "undefined"){
                this.snackbar.text = prom.data.messages
            }else{
                this.snackbar.text = "İşlem başarılı.";
            }
            this.$emit("success",prom.data);
        }catch (error) {
            this.snackbar = new snackbar();
            this.snackbar.color = "error";
            this.onFly = false;
            this.snackbar.text = this.$helper.errorHandler(error);
            this.snackbar.enabled = true;
            /*
            if(typeof e.data.message != "undefined"){
                this.snackbar.text = e.data.message
            }else{
                this.snackbar.text = e.message;
            }
            */
        }

        /*
        //request<T = any, R = AxiosResponse<T>> (config: AxiosRequestConfig): Promise<R>;
        Vue.prototype.$http.request(this.config).then( (response:AxiosResponse)=>{
            this.$emit('success', response.data );
        }).catch( (error:AxiosError)=>{
            this.error = error;
        }).finally( ()=>{
            this.onFly=false;
        });
        */
    }
}

